import { warehouseCollectionSaveOtherCollectionData } from '$downLoading/apis/warehouse';
import { getSessionId } from '$common/utils/session-id'
import languageUtils from '$common/utils/language';

export const getSsrConfig = () => {
  const config = window.ssrConfig
  if (config) {
    return config.routerConfig
  }
  return {}
}

export const getConfigValue = (key) => {
  const conf = getSsrConfig() || {}
  return conf[key]
}

export const getDevice = () => {
  const agent = navigator.userAgent
  if (['android', 'linux'].filter(e => agent.toLocaleLowerCase().indexOf(e) !== -1).length) {
    return 'Android';
  }
  if (['iphone', 'ipad'].filter(e => agent.toLocaleLowerCase().indexOf(e) !== -1).length) {
    return 'iOS';
  }
  if (agent.toLocaleLowerCase().indexOf('mac os x') > -1) {
    return 'Mac OS X';
  }
  return 'Windows';
}

export const getStruct = ({ businessName, eventGroup, event, sessionid, ext, spm, loginName, operatorNo, longitude, latitude }) => {
  // https://www.tapd.cn/40405544/prong/stories/view/1140405544001015404 参考结构
  if (!event || !businessName || !eventGroup) {
    return console.error('埋点数据结构不完整')
  }

  const pageHeader = getConfigValue('pageHeader') || {}
  const language = languageUtils.getPageHeaderCurrentLanguage || 'km-KH'
  const deviceType = pageHeader['device-type'] || getDevice()

  return {
    appNo: 21,
    // appId: "H5",
    appId: "SuperAPP",
    sessionid: sessionid || getSessionId(),
    spm: spm || {},
    event,
    ext: Object.assign({
      url: window.location.href
    }, ext),
    eventGroup,
    businessName,
    recordTime: Date.now(),
    language,
    deviceType,
    longitude: longitude || null,
    latitude: latitude || null,
    operatorNo: operatorNo || null,
    loginName: loginName || null
  }
}

export const getPerformanceData = () => {
  const timing = window.performance.timing;
  const start = timing.navigationStart;
  const timingObj = {
    DNSResolutionTime: timing.domainLookupEnd - timing.domainLookupStart,
    TCPEstablishmentTime: timing.connectEnd - timing.connectStart,
    TimeConsumingToParseTheDOMTree: timing.domComplete - timing.domInteractive,
    onePageTime: timing.responseStart - start,
    domRenderingCompletionTime: timing.domContentLoadedEventEnd - start,
    pageLoadTime: timing.loadEventEnd - start
  };
  return timingObj
}

export const uploadTrackingData = (data) => warehouseCollectionSaveOtherCollectionData(data)